package ir.site.zero1plus

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import com.varabyte.kobweb.browser.storage.createStorageKey
import com.varabyte.kobweb.browser.storage.getItem
import com.varabyte.kobweb.browser.storage.setItem
import com.varabyte.kobweb.compose.css.OverscrollBehavior
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.OverscrollBehaviorScope
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxHeight
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.overscrollBehavior
import com.varabyte.kobweb.compose.ui.modifiers.scrollMargin
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.core.App
import com.varabyte.kobweb.core.AppGlobals
import com.varabyte.kobweb.core.isExporting
import com.varabyte.kobweb.silk.SilkApp
import com.varabyte.kobweb.silk.components.layout.Surface
import com.varabyte.kobweb.silk.components.overlay.OverlayStyle
import com.varabyte.kobweb.silk.init.InitSilk
import com.varabyte.kobweb.silk.init.InitSilkContext
import com.varabyte.kobweb.silk.init.registerStyleBase
import com.varabyte.kobweb.silk.style.common.SmoothColorStyle
import com.varabyte.kobweb.silk.style.toModifier
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import com.varabyte.kobweb.silk.theme.modifyStyle
import kotlinx.browser.document
import kotlinx.browser.localStorage


val COLOR_MODE_KEY = ColorMode.entries.createStorageKey("app:colorMode")

fun Modifier.direction(direction:String) = styleModifier {
    property("direction", direction)
}

@InitSilk
fun initStyles(ctx: InitSilkContext) {
//    ctx.stylesheet.registerStyleBase("html, body") { Modifier.fillMaxHeight() }
    ctx.stylesheet.registerStyleBase("html") {
        Modifier.direction("rtl")
            .styleModifier { property("scroll-behavior" , "smooth") }

    }
    ctx.stylesheet.registerStyleBase("body"){
        Modifier.fontFamily("Vazirmatn")
    }
    ctx.config.apply {
        initialColorMode = localStorage.getItem(COLOR_MODE_KEY) ?: ColorMode.DARK
        // Script which runs at load time that needs to be kept in sync with `initialColorMode` above. This code checks
        // if the user's local color mode preference is different from what was exported by Kobweb, replacing it if
        // different to prevent a flash of color after the page loads.
        if (AppGlobals.isExporting) {
            document.head!!.appendChild(
                document.createElement("script").apply {
                    textContent = """
                            {
                                const storedColor = localStorage.getItem('${COLOR_MODE_KEY.name}'); // 'LIGHT', 'DARK', or null
                                const desiredColor = storedColor
                                    ? `silk-${'$'}{storedColor.toLowerCase()}`
                                    : (window.matchMedia('(prefers-color-scheme: dark)').matches ? 'silk-dark' : 'silk-light');
                                const oppositeColor = desiredColor === 'silk-dark' ? 'silk-light' : 'silk-dark';
                                document.documentElement.classList.replace(oppositeColor, desiredColor);
                            }
                            """.trimIndent()
                })
        }
    }

}

@App
@Composable
fun AppEntry(content: @Composable () -> Unit) {
    SilkApp {
        val colorMode = ColorMode.current
        LaunchedEffect(colorMode) {
            localStorage.setItem(COLOR_MODE_KEY, colorMode)
        }
        Surface(SmoothColorStyle.toModifier().fillMaxHeight()) {
            content()
        }
    }
}
